module.exports = __webpack_public_path__ + "media/13.1dfa5406.mp3";